export default "__VITE_ASSET__CMqFOFuq__"